/**
 * Sanitize chat messages before sending to backend API endpoints.
 *
 * Strips heavy frontend-only fields (imageUrl with base64 data, id, timestamp,
 * isStreaming) so payloads stay under the ai-tier 2 MB body limit.
 * The backend only needs: sender, text, type, webSearchResults.
 */
export function sanitizeChatMessages<
  T extends { sender: string; text: string; type?: string; webSearchResults?: unknown[] },
>(messages: T[]): Array<{ sender: string; text: string; type?: string; webSearchResults?: unknown[] }> {
  return messages.map(({ sender, text, type, webSearchResults }) => {
    const msg: { sender: string; text: string; type?: string; webSearchResults?: unknown[] } = { sender, text };
    if (type) msg.type = type;
    if (webSearchResults) msg.webSearchResults = webSearchResults;
    return msg;
  });
}
